'use strict';

/**
 * Converts the first character of a string to lowercase.
 *
 * @param str - The string to uncapitalize.
 * @returns The uncapitalized string.
 */ function unCapitalize(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}

module.exports = unCapitalize;
